import React from 'react';
import { useProjectConfig } from '../hooks/useProjectConfig';
import SystemArchitecturePVQ from './SystemArchitecturePVQ';
import SystemArchitecturePDT from './SystemArchitecturePDT';

/**
 * Router component that displays the appropriate System Architecture
 * component based on the selected project.
 */
const SystemArchitecture: React.FC = () => {
  const projectConfig = useProjectConfig();

  // Route to appropriate architecture component based on project slug
  switch (projectConfig.slug) {
    case 'pvq-ai':
      return <SystemArchitecturePVQ />;
    case 'pdt-project':
      return <SystemArchitecturePDT />;
    default:
      // Default to PVQ if no match (backward compatibility)
      return <SystemArchitecturePVQ />;
  }
};

export default SystemArchitecture;
